<template>
  <div class="page-wrap">

    <header
        v-if="[3,4,5,6,7].includes(pageType)"
        class="header">
      <div class="top"></div>

      <div class="opera">
        <el-button
            v-if="[3,4,5].includes(pageType)"
            icon="Back" link
            @click="goBack"
        >返回
        </el-button>

        <el-button type="primary"
                   style="margin-left: 20px;margin-right: 10px;"
                   link
                   @click="goHome"
        >首页
        </el-button>

        <span style="margin-right: 10px;">></span>

        <template v-if="pageType == 5">
          申报反馈
        </template>

        <template v-else-if="pageType == 6 || pageType == 7">
          税费缴纳
        </template>

        <template v-else>
          {{ currentTitle }}
        </template>
      </div>

    </header>

    <login
        v-if="pageType == 1"
        :current-qa="currentQa"
        @loginSuccess="pageType = 2"
        @goSuccess="pageType = 5"
    />

    <shouye
        v-if="pageType == 2"
        :current-qa="currentQa"
        @startFill="pageType = 3"
        @yhs="pageType = 31"
    />

    <before-exe
        v-if="pageType == 3 && currentQa.sonQueType != '201'"
        :current-qa="currentQa"
        @startExam="pageType = 4"
        @finish="pageType = 5"
    />

    <before-exe201
        v-if="pageType == 3 && currentQa.sonQueType == '201'"
        :current-qa="currentQa"
        @startExam="pageType = 4"
        @finish="pageType = 5"
    />

    <exe-question
        v-if="pageType == 4"
        :current-qa="currentQa"
        ref="exeQueRef"
        @finish="pageType = 5"
    />

    <report-success
        v-if="pageType == 5"
        :current-qa="currentQa"
        @backHome="pageType = 2"
        @payTax="pageType = 6"
    />

    <tax-payment
        v-if="pageType == 6"
        :current-qa="currentQa"
        @payFinish="pageType = 7"
    />

    <tax-pay-success
        v-if="pageType == 7"
        :current-qa="currentQa"
        @backHome="pageType = 2"
    />

    <yhs
        v-if="pageType == 31"
        :current-qa="currentQa"
        @goHome="pageType = 2"
        @goBack="pageType = 2"
        @finish="pageType = 5"
    />


  </div>
</template>

<script setup name="TaxQuestionManager">
import login from "./page/login.vue";
import Shouye from "./page/shouye.vue";
import BeforeExe from "./page/beforeExe.vue";
import BeforeExe201 from "./page/beforeExe201.vue";
import ExeQuestion from "./page/exeQuestion.vue";
import ReportSuccess from "./page/reportSuccess.vue";
import TaxPayment from "./page/taxPayment.vue";
import TaxPaySuccess from "./page/taxPaySuccess.vue";
import yhs from './yhs'
import {$on} from "vue-happy-bus";
import {isAlReadyLogin} from "@/views/examCenter/reportTax/reportTaxLoginHandler.js";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const pageType = ref(1) // 页面类型 1登录页  2首页   3做题前置页  4实际做题页(即做题主页面)   5申报成功页面
// 小规模、一般纳税人才有的增加页面：6 立即缴款页面  7缴款成功页面

// 31 印花税页面

onMounted(() => {
  if(isAlReadyLogin()) {
    pageType.value = 2
  }
})



const currentTitle = computed(() => {
  switch (props.currentQa.sonQueType) {
    case '21':
      return '增值税及附加税费申报(小规模纳税人适用)'
    case '22': // 企税--小规模
    case '2201':
      return '居民企业（查账征收）企业所得税月（季）度申报'
    case '23':
      return '增值税及附加税费申报(一般纳税人适用)'
    case '26': // 企税--一般纳税人
    case '2601':
      return '居民企业（查账征收）企业所得税月（季）度申报'
    case '27':
    case '28':
    case '29':
      return '财务报表报送及更正'
    case '201':
      return '居民企业（查账征收）企业所得税年度申报'
  }
})

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getResetData = () => {
  return {
    solution: ''
  }
}
getGrandchildValue.value.fillFinish = () => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll?.status == 1 || false
}

let saveBackType = null // 回退保存页面类型：null表示默认值，无需处理  3表示做题页返回前面的页面  2表示做题页返回首页

//返回页处理
async function goBack() {
  if (pageType.value == 4 && qaData.value.status != 1) { // 做题页面且未提交，返回前一个页面，需要调用保存，来回调实现
    exeQueRef.value && exeQueRef.value.taxSave()
    saveBackType = 3
    return
  }
  saveBackType = null
  if ([3, 4].includes(pageType.value)) {
    pageType.value--
    return
  }
  if (pageType.value == 5) {
    pageType.value = 2
  }
}

//回到首页
function goHome() {
  if (pageType.value == 4 && qaData.value.status != 1) { // 做题页面且未提交，回到首页，需要调用保存，来回调实现
    exeQueRef.value && exeQueRef.value.taxSave()
    saveBackType = 2
    return
  }
  saveBackType = null
  pageType.value = 2
}

const exeQueRef = ref()

const qaData = computed(() => {
  const taxDataAll = props.currentQa?.solution && JSON.parse(props.currentQa.solution) || null
  return taxDataAll == null ? JSON.parse(props.currentQa.answer) : taxDataAll
})


// 爷爷组件，保存成功回调
$on('saveQaSuccess', () => {
  if ([2, 3].includes(saveBackType)) {
    pageType.value = saveBackType
    saveBackType = null
  }
})


</script>

<style scoped lang="scss">
.page-wrap {
  height: 100%;

  .header {
    .top {
      height: 56px;
      background-image: url(https://static.rhkj.com/renhe_fe/other/316.png);
      background-size: cover;
    }

    .opera {
      color: #333333;
      font-size: 14px;
      display: flex;
      align-items: center;
      height: 40px;
      padding-left: 20px;
    }
  }
}
</style>
